/*
 * @Author: Teemo Ding
 * @Date: 2021-11-25 14:34:53
 * @LastEditTime: 2023-02-20 15:03:30
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Additional/index.tsx
 */
import { saveAdditionalItemRequest } from '@/src/request/order/additionalItem';
import { useRequest } from 'ahooks';
import React from 'react';
import ProductsItems from '../ProductsItems';

import css from './css.module.less';

const AdditionalItem = (props) => {
  const {
    salesChannelUuid,
    orderUuid,
    selectedItems,
    AdditionalUuid,
    currency,
    disable,
    onSave,
  } = props;
  const [additionalItems, setAdditionalItems] = React.useState(
    selectedItems || [],
  );
  const { run: _saveAdditionalItemRequest } = useRequest(
    () =>
      saveAdditionalItemRequest({
        uuid: AdditionalUuid,
        orderUuid,
        items: additionalItems,
      }),
    {
      manual: true,
      onSuccess: (res) => onSave(res),
    },
  );
  return (
    <div className={css.containerClassName}>
      <ProductsItems
        salesChannelUuid={salesChannelUuid}
        AdditionalUuid={AdditionalUuid}
        value={additionalItems}
        disabled={disable}
        createRequest={_saveAdditionalItemRequest}
        onChange={setAdditionalItems}
        currency={currency}
        keyUuid={'keyUuid'}
      />
    </div>
  );
};

export default AdditionalItem;
